/**
 * AUTOMATIONS PAGE — Pagina "Automazioni" raggiunta dalla voce di menu.
 * Rende la schermata `id="list"` del mockup
 * (`config/automazioni e insights/crm-mockup.html`): la TABELLA delle
 * automazioni (nome/sottotitolo, stato, esecuzioni/successi/errori, ultima
 * esecuzione, menu azioni), con toolbar di filtro stato + ricerca +
 * "Nuova automazione". La tabella è implementata da AutomationList, che è
 * self-contained (list-card + toolbar come TaskList): la pagina la rende
 * direttamente, senza wrapper di padding (coerente con la pagina Task).
 *
 * NB: la template gallery a card (AutomationGallery) corrisponde invece alla
 * schermata `id="templates"` del mockup (blueprint da cui creare una nuova
 * automazione), non a questa lista.
 */

import AutomationList from '../../entities/automation/AutomationList';

export function AutomationsPage() {
  return <AutomationList />;
}